/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { getPayPalInformation } from 'state/actions/accountState/account_data';
// component
import PayPal from 'pages/dashboard/account/paymentinfo/selectmethod/paypal/paypal';



/* ========== ~~~~~~~~~~ PAYPAL : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.PAYPAL.fields,
    hasStoredData: Object.keys(accountData.PAYPAL.storedData).length > 1,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentUUID: accountData.paymentUUID,
    editable: accountData.PAYPAL.editable,
    storedData: accountData.PAYPAL.storedData,
    preferredPaymentType: accountData.preferredPaymentType,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    getPayPalInformation: (hasStoredData, formName, paymentUUID) => dispatch(getPayPalInformation(hasStoredData, formName, paymentUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PayPal);
